import { axiosInstance } from "../../../utils/axios_config"

export default function IntegrationVehicleService() {

    this.getVehicles = async (payload) => {
        return axiosInstance.post('Vehicle', payload);
    }
}